import { render, staticRenderFns } from "./ProductTierPercentage.vue?vue&type=template&id=175032d4&"
import script from "./ProductTierPercentage.vue?vue&type=script&lang=ts&"
export * from "./ProductTierPercentage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports